// src/components/layouts/SiteHeader.jsx
import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useConfig } from "../../config/ConfigContext";

export function SiteHeader({ brand, children }) {
  const cfg = useConfig();
  const siteBrand = brand ?? cfg.siteName ?? "";

  return (
    <header className="site-header-fixed-container" role="banner">
      <a className="visually-hidden-focusable" href="#main">
        Skip to content
      </a>

      {/* LOGO BAR */}
      {siteBrand && (
        <div className="logo-bar">
          <div className="container text-center">
            <NavLink to="/" className="logo-link">
              <div className="logo-text-center">
                {siteBrand}
              </div>
            </NavLink>
          </div>
        </div>
      )}

      {/* NAVIGATION BAR */}
      <Navbar expand="lg" className="site-navbar w-100">
        <div className="container">
          <Navbar.Toggle aria-controls="main-nav" />

          <Navbar.Collapse id="main-nav">
            <Nav className="main-nav mx-auto">
              {children}
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>
  );
}

// NavItem works with either `to` or `href`
export function NavItem({ to, href, children }) {
  const target = to ?? href ?? "#";
  return (
    <Nav.Link
      as={NavLink}
      to={target}
      end
      className={({ isActive }) => (isActive ? "fw-bold" : undefined)}
    >
      {children}
    </Nav.Link>
  );
}